export default (str) => (str === null ? "SEED" : `${str} | SEED`);
